// ─────────────────────────────────────────────────────────────────────────────
// What a failed write says to the doctor (DESIGN_CONCEPT §2.4, §7).
//
// Two kinds of error reach a catch block, and they must not be treated alike:
//
//   • a refusal the BFF wrote FOR PEOPLE — `userError(messageKey, text)` puts a
//     `messageKey` in `extensions` («عضویت شما در این مرکز یافت نشد…»). That is
//     the most useful thing the screen can say: translated when the catalogue has
//     the key, the server's own sentence when it does not yet;
//   • everything else — «Failed to fetch», a gRPC status, a stack fragment. Raw
//     transport text is never shown; the caller's translated fallback is.
// ─────────────────────────────────────────────────────────────────────────────

export function userErrorMessage(err, { t, has }, fallbackKey = 'errors.save.generic') {
  const key = err?.extensions?.messageKey;
  if (key) {
    if (typeof has === 'function' && has(key)) return t(key);
    if (err?.message) return String(err.message);
  }
  return t(fallbackKey);
}

export default userErrorMessage;
